import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Grid.scss';

class Row extends Component {
  render() {
    const { className } = this.props;
    const customClass = className ? ` ${className}` : ''

    return (
      <div className={'row' + customClass}>
        {this.props.children}
      </div>
    );
  }
}

Row.propTypes = {
  className: PropTypes.string,
};

Row.defaultProps = {
  className: null,
}

class Column extends Component {
  render() {
    const { className, flex } = this.props;

    const flexClass = flex ? ' column-flex' : ''
    const customClass = className ? ` ${className}` : ''

    return (
      <div className={'column' + flexClass + customClass}>
        {this.props.children}
      </div>
    );
  }
}

Column.propTypes = {
  className: PropTypes.string,
  flex: PropTypes.bool
};

Column.defaultProps = {
  className: null,
  flex: true
}

export { Row, Column };